export const DESKTOP = 1024;